import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCrmLeadsCallsList,
  getCrmLeadsEmailsList,
  postCrmLeadsCall,
  postCrmLeadsEmail,
} from "../../../api/crmLeads";
import {
  crmCallsTable,
  crmEmailsTable,
} from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import AgGridPaginatedTable from "../../../component/AgGridPaginatedTable";
import ItemDialogTabCall from "./item.dialog.call.desc";

export default function CRMLeadsCallsCardList() {
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const [itemDialog, setItemDialog] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  async function loadMasterData(limit, offset) {
    try {
      const { data } = await getCrmLeadsCallsList(
        {
          lead_id: params.id,
          limit: limit,
          offset: offset,
        },
        user.token
      );

      return {
        rows: data.records,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      //   setLoading(false);
    }
  }
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  const onItemDialogSubmit = async (postData) => {
    const combineData = { ...postData, lead_id: params.id };
    try {
      const { data } = await postCrmLeadsCall(combineData, user.token);
      refreshTable();
      dispatch(showAlert(data.msg));
      setItemDialog(false);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Lead Calls
          </Typography>
        </Box>

        <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
          <Button
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
              marginRight: "10px",
            }}
            onClick={() => {
              navigate(-2);
            }}
            className="blue-button"
          >
            Go Back
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            variant="contained"
            sx={{
              padding: "5px 7px",
              fontSize: { xs: "10px", sm: "12px" },
            }}
            onClick={() => {
              setItemDialog(true);
            }}
            className="blue-button"
          >
            Create
          </Button>
        </Box>
      </Box>
      <br />
      <div>
        <AgGridPaginatedTable
          getTableRows={loadMasterData}
          columns={crmCallsTable}
          perPage={10}
          refreshCounter={tableRefreshCount}
          // rowSelection="single"
          //   onRowClicked={(params) => {
          //     setSelectedEmployeeRow(params.data.ep_id);
          //   }}
        />
      </div>

      <ItemDialogTabCall
        open={itemDialog}
        setOpen={setItemDialog}
        onSubmit={onItemDialogSubmit}
      />
    </Box>
  );
}

// import React, { useEffect, useRef, useState } from "react";
// import {
//   Badge,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   IconButton,
//   Paper,
//   Typography,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   Grid,
//   TextField,
// } from "@mui/material";
// import { CallEndOutlined, EmailOutlined, MoreVert } from "@mui/icons-material";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import {
//   getCrmLeadsCallsList,
//   getCrmLeadsEmailsList,
//   getCrmLeadsList,
//   postCrmLeadsCall,
//   postCrmLeadsEmail,
// } from "../../../api/crmLeads";
// import { handleAxiosError } from "../../../config/action-config";
// import { useDispatch, useSelector } from "react-redux";
// import ReactPaginate from "react-paginate";
// import { useNavigate, useParams } from "react-router-dom";
// import { showAlert } from "../../../actions/alert";
// import { useForm } from "react-hook-form";
// export default function CRMLeadsCallsCardList() {
//   const params = useParams();
//   const [itemDialog, setItemDialog] = useState(false);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [items, setItems] = useState([]);
//   const [pageCount, setpageCount] = useState(0);
//   const user = useSelector((state) => state.user);
//   const dispatch = useDispatch();
//   let limit = 10;

//   const fetchData = async (currentPage) => {
//     setLoading(true);
//     try {
//       const { data } = await getCrmLeadsCallsList(
//         {
//           lead_id: params.id,
//           limit: limit,
//           offset: currentPage * limit,
//         },
//         user.token
//       );

//       const total = data.total;
//       setpageCount(Math.ceil(total / limit));
//       setItems(data.records);
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       handleAxiosError(error, dispatch);
//     }
//   };

//   useEffect(() => {
//     fetchData(0);
//   }, [limit]);

//   const handlePageClick = async (data) => {
//     const currentPage = data.selected;
//     fetchData(currentPage);
//   };
//   const onItemDialogSubmit = async (postData) => {
//     const combineData = { ...postData, lead_id: params.id };
//     try {
//       const { data } = await postCrmLeadsCall(combineData, user.token);
//       fetchData(0);
//       dispatch(showAlert(data.msg));
//       setItemDialog(false);
//     } catch (error) {
//       handleAxiosError(error, dispatch);
//     }
//   };
//   const cardContainerStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "10px",
//     justifyContent: "space-around",
//     padding: "10px",
//   };

//   const cardStyle = {
//     flex: "0 0 calc(33.333% - 20px)",
//     maxWidth: "calc(33.333% - 20px)",
//     boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
//     boxSizing: "border-box",
//   };

//   const paperStyle = {
//     width: "100%",
//     height: "100%",
//     position: "relative", // Set the position property to relative
//   };
//   const buttonStyle = {
//     position: "absolute",
//     top: "10px", // Position the button 10px from the top
//     right: "10px", // Position the button 10px from the right
//   };
//   return (
//     <>
//       <Paper style={paperStyle}>
//         <div style={buttonStyle}>
//           <Button
//             variant="contained"
//             sx={{
//               padding: "5px 7px",
//               fontSize: { xs: "10px", sm: "12px" },
//             }}
//             onClick={() => {
//               setItemDialog(true);
//             }}
//             className="blue-button"
//           >
//             Create
//           </Button>
//         </div>
//         <div>
//           {items.length ? (
//             <div style={{ paddingTop: 10 }}>
//               <ReactPaginate
//                 previousLabel="< previous"
//                 nextLabel="next >"
//                 breakLabel={"..."}
//                 pageCount={pageCount}
//                 marginPagesDisplayed={2}
//                 pageRangeDisplayed={3}
//                 onPageChange={handlePageClick}
//                 activeClassName={"custom-active-class"} // Change this to your desired custom class name
//                 containerClassName={"pagination justify-content-center"}
//                 pageClassName={"page-item"}
//                 pageLinkClassName={"page-link"}
//                 previousClassName={"page-item"}
//                 previousLinkClassName={"page-link"}
//                 nextClassName={"page-item"}
//                 nextLinkClassName={"page-link"}
//                 breakClassName={"page-item"}
//                 breakLinkClassName={"page-link"}
//               />
//             </div>
//           ) : (
//             <div className="page d-flex">
//               <div className="m-auto text-center">
//                 <Typography variant="h6" fontWeight="600">
//                   No rows to show.
//                 </Typography>
//               </div>
//             </div>
//           )}
//           {loading === false ? (
//             <div style={cardContainerStyle}>
//               {items.map((item, index) => (
//                 <Card
//                   variant="outlined"
//                   key={index}
//                   style={{
//                     ...cardStyle,
//                     marginBottom: "10px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       padding: "10px ",
//                     }}
//                   >
//                     <IconButton>
//                       <MoreVert />
//                     </IconButton>
//                   </div>
//                   <CardContent style={{ backgroundColor: "#f5f5f5" }}>
//                     <div
//                       style={{
//                         display: "flex",
//                         flexDirection: "row",
//                         flexWrap: "wrap",
//                         // padding: "5px",
//                       }}
//                     >
//                       <div style={{ flex: "1" }}>
//                         <Typography variant="body2">
//                           <span
//                             style={{
//                               fontSize: 10,
//                               color: "#808080",
//                               //   fontWeight: "bold",
//                             }}
//                           >
//                             Call By :
//                           </span>
//                           <span style={{ fontSize: 10, fontWeight: "bold" }}>
//                             {item.call_by}
//                           </span>
//                         </Typography>
//                         <Typography variant="body2">
//                           <span
//                             style={{
//                               fontSize: 10,
//                               color: "#808080",
//                               //   fontWeight: "bold",
//                             }}
//                           >
//                             Call Date :
//                           </span>
//                           <span style={{ fontSize: 10, fontWeight: "bold" }}>
//                             {item.call_date}
//                           </span>
//                         </Typography>
//                         <Typography variant="body2">
//                           <span
//                             style={{
//                               fontSize: 10,
//                               color: "#808080",
//                               //   fontWeight: "bold",
//                             }}
//                           >
//                             Call Discussion :
//                           </span>
//                           <span style={{ fontSize: 10, fontWeight: "bold" }}>
//                             {item.call_discussion}
//                           </span>
//                         </Typography>

//                         {/* Add more fields as needed */}
//                       </div>
//                     </div>
//                   </CardContent>
//                 </Card>
//               ))}
//             </div>
//           ) : (
//             <div className="page d-flex">
//               <div className="m-auto text-center">
//                 <Typography variant="h6" fontWeight="600">
//                   Loading...
//                 </Typography>
//                 <br />
//                 <CircularProgress />
//               </div>
//             </div>
//           )}
//         </div>
//       </Paper>
//       <ItemDialogTab
//         open={itemDialog}
//         setOpen={setItemDialog}
//         onSubmit={onItemDialogSubmit}
//       />
//     </>
//   );
// }
// const emptyItemData = {
//   call_discussion: "",
// };
// function ItemDialogTab({ open, setOpen, onSubmit }) {
//   const user = useSelector((state) => state.user);
//   const [loader, setLoader] = useState(false);
//   const dispatch = useDispatch();
//   const {
//     register,
//     handleSubmit,
//     control,
//     setError, // Add setError function
//     reset,
//     formState: { errors },
//   } = useForm({ defaultValues: emptyItemData });

//   const submit = (data) => {
//     setLoader(true);
//     onSubmit(data).then(() => {
//       setLoader(false);
//     });
//   };

//   // Use the clearStatusFieldError function when the dialog is opened
//   useEffect(() => {
//     if (open) {
//       // Reset the form when the dialog is opened
//       reset(emptyItemData);
//     }
//   }, [open, reset]);

//   return (
//     <Dialog
//       open={open}
//       onClose={() => {
//         // setOpen(false);
//       }}
//       aria-labelledby="alert-dialog-title"
//       aria-describedby="alert-dialog-description"
//     >
//       <DialogTitle id="alert-dialog-title" sx={{ textTransform: "capitalize" }}>
//         Add Call Description
//       </DialogTitle>
//       <DialogContent>
//         <Grid container width={500} spacing={1} py={1}>
//           <Grid item xs={12}>
//             <TextField
//               label="Call Description"
//               name="call_discussion"
//               fullWidth
//               multiline={true}
//               rows={3}
//               inputRef={register({
//                 required: "Call description is required.",
//               })}
//               required
//               error={Boolean(errors.call_discussion)}
//               helperText={errors.call_discussion?.message}
//             />
//           </Grid>
//         </Grid>
//       </DialogContent>
//       <DialogActions>
//         <Button
//           onClick={() => {
//             setOpen(false);
//           }}
//           className="cancel-button"
//         >
//           Cancel
//         </Button>

//         {loader ? (
//           <div className="overlay">
//             <Loading></Loading>
//           </div>
//         ) : (
//           <Button className="blue-button" onClick={handleSubmit(submit)}>
//             {"Submit"}
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// }
// function Loading() {
//   return (
//     <div className="page d-flex">
//       <div className="m-auto text-center">
//         <CircularProgress />
//       </div>
//     </div>
//   );
// }
